module.exports = __webpack_public_path__ + "media/ping.f059a73b.mp4";